/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { useHistory, Link } from 'react-router-dom';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import TarifasModal from '../TarifasModal';
import { useToast } from '../../../../hooks/toast';
import EmployeeService from '../../../../services/employee';
import DepartamentosService, {
  Departamento,
} from '../../../../services/departamentos';
import { isValidCpf } from '../../../../utils/isValidCpf';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Loader from '../../../../components/Loader';
import InputOutlined from '../../../../components/InputOutLined';
import SelectOutLined from '../../../../components/SelectOutLined';
import Checkbox from '../../../../components/Checkbox';
import Button from '../../../../components/Button';
import {
  Row,
  Column,
  InfoContainer,
  InfoItem,
  IconContainer,
} from '../../../../styles/components';
import { Container, Title, SubTitle, Card } from './styles';

const schema = Yup.object().shape({
  Nome: Yup.string().required('Nome é obrigatório'),
  Matricula: Yup.string().required(
    'Esse campo é obrigatório. Caso não haja um número de matrícula utilize o CPF.',
  ),
  FuncCpf: Yup.string().test('cpf-validation', 'CPF Inválido', (value: any) => {
    const isValid = isValidCpf(value);
    if (!value) {
      return true;
    }
    return isValid;
  }),
  /* .required('CPF é obrigatório'), */
  // CodigoDepartamento: Yup.string().required('Departamento é obrigatório'),
  // Telefone: Yup.string().max(15, 'O número Máximo de caractéres é 15'),
});

const AddEmployee: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const formTarifasRef = useRef<FormHandles>(null);
  const service = { EmployeeService: new EmployeeService() };
  const serviceDepto = { DepartamentosService: new DepartamentosService() };
  const [showTarifas, setShowTarifas] = useState<boolean>(false);
  const { addToast } = useToast();
  const { push } = useHistory();
  const [loader, setLoader] = useState<boolean>(true);
  const [statusChecked, setStatusChecked] = useState<boolean>(true);
  const [departamentos, setDepartamentos] = useState<Departamento[]>([]);
  const [tarifas, setTarifas] = useState<any>();
  const [addTarifas, setAddTarifas] = useState<any>([
    { tarifaName: '', quantidade: 0 },
  ]);

  const getDepartments = useCallback(async () => {
    try {
      const response =
        await serviceDepto.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  }, []);

  const getTarifas = useCallback(async () => {
    try {
      const response = await service.EmployeeService.getFares();
      setTarifas(response.data.ListaInformacoesDeTarifa);
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  }, []);

  const departamentoOptions = useMemo(() => {
    const changedDepartamentos = departamentos.map(
      (departamento: Departamento) => {
        return {
          value: String(departamento.CodigoDepartamento),
          label: departamento.Nome,
        };
      },
    );
    return changedDepartamentos;
  }, [departamentos]);

  const tarifasOptions = useMemo(() => {
    const changedTarifas = tarifas?.map((tarifa: any) => {
      return {
        value: tarifa.CodigoDaTarifa,
        label: tarifa.Descricao,
      };
    });
    return changedTarifas;
  }, [tarifas]);

  const handleAddTarifa = useCallback(() => {
    if (addTarifas.length < 4) {
      setAddTarifas([...addTarifas, { tarifaName: '', quantidade: 0 }]);
    }
  }, [addTarifas]);

  const getChangedTarifas = useCallback((data: any) => {
    return {
      CodigoTarifa1: data.length >= 1 ? String(data[0].tarifa) : null,
      QuantidadeTarifa1: data.length >= 1 ? String(data[0].quantidade) : null,
      CodigoTarifa2: data.length >= 2 ? String(data[1].tarifa) : null,
      QuantidadeTarifa2: data.length >= 2 ? String(data[1].quantidade) : null,
      CodigoTarifa3: data.length >= 3 ? String(data[2].tarifa) : null,
      QuantidadeTarifa3: data.length >= 3 ? String(data[2].quantidade) : null,
      CodigoTarifa4: data.length >= 4 ? String(data[3].tarifa) : null,
      QuantidadeTarifa4: data.length >= 4 ? String(data[3].quantidade) : null,
    };
  }, []);

  const handleRemoveTarifa = useCallback(
    (index: any) => {
      const arr = addTarifas;
      arr.splice(index, 1);
      setAddTarifas([...arr]);
    },
    [addTarifas],
  );

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });
      const tarifasData: any = formTarifasRef.current?.getData();

      const ConvertedTarifas =
        Object.values(tarifasData).length > 0
          ? getChangedTarifas(tarifasData.tarifas)
          : {
              CodigoTarifa1: null,
              QuantidadeTarifa1: null,
              CodigoTarifa2: null,
              QuantidadeTarifa2: null,
              CodigoTarifa3: null,
              QuantidadeTarifa3: null,
              CodigoTarifa4: null,
              QuantidadeTarifa4: null,
            };

      const StatusData = data.Status.length ? data.Status[0] : 'I';
      const changedCpf = data.FuncCpf.replace(/\D/g, '');
      const AddData = {
        ...data,
        Status: StatusData,
        FuncCpf: changedCpf || null,
        CodigoTarifa1: ConvertedTarifas.CodigoTarifa1,
        CodigoTarifa2: ConvertedTarifas.CodigoTarifa2,
        CodigoTarifa3: ConvertedTarifas.CodigoTarifa3,
        CodigoTarifa4: ConvertedTarifas.CodigoTarifa4,
        QuantidadeTarifa1: ConvertedTarifas.QuantidadeTarifa1,
        QuantidadeTarifa2: ConvertedTarifas.QuantidadeTarifa2,
        QuantidadeTarifa3: ConvertedTarifas.QuantidadeTarifa3,
        QuantidadeTarifa4: ConvertedTarifas.QuantidadeTarifa4,
      };
      delete AddData.status;

      setLoader(true);
      await service.EmployeeService.addEmployee(AddData);

      addToast({
        type: 'success',
        title: 'Cadastro Finalizado',
        description: 'Usuário cadastrado com sucesso!!',
      });
      setLoader(false);
      push('/funcionarios');
    } catch (err: any) {
      const { ...error } = err;

      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);

        addToast({
          type: 'info',
          title: 'Ainda há campos que precisam ser preenchidos',
          description: 'Por favor Preencha os campos Obrigatórios',
        });

        return;
      }

      setLoader(false);

      if (error.response.data.Summary.ErrorCollection.DataValidationErros[0]) {
        addToast({
          type: 'error',
          title:
            error.response.data.Summary.ErrorCollection.DataValidationErros[0]
              .ErrorMessage,
          description:
            error.response.data.Summary.ErrorCollection.DataValidationErros[0]
              .InternalErrorMessage,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Erro ao cadastrar',
          description:
            error.response.data.Summary.ErrorCollection.SystemFailureErros[0]
              .InternalErrorMessage,
        });
      }
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      setLoader(true);
      await getDepartments();
      await getTarifas();
      setLoader(false);
    };
    init();
  }, []);

  return (
    <Container>
      {loader && <Loader />}
      <Row className="titleWrapper">
        <Column small="2" medium="2" large="2">
          <IconContainer align="center">
            <HiOutlineUserGroup size={112} />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>
            Cadastrar Funcionário
            <Link to="/funcionarios">
              <AiOutlineArrowLeft size={30} style={{ color: '#3F1159' }} />
            </Link>
          </Title>
          <SubTitle>
            Para fazer a recarga, é necessário que o seu cartão BHBUS esteja
            atrelado a algum funcionário. Aqui, você cadastra o funcionário que
            irá utilizar o cartão.
          </SubTitle>
        </Column>
      </Row>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Row className="CardContainer1">
          <Column small="2" medium="2" large="2">
            <InfoContainer className="infoitem">
              <InfoItem>
                <span className="info">&#9432;</span>
                <span>
                  <b>Nome e Matrícula</b>
                  &nbsp; são dados &nbsp;
                  <b>obrigatórios</b>
                  &nbsp; para registro de funcionários.
                </span>
              </InfoItem>
              <InfoItem className="infoitem">
                <span className="info">&#9432;</span>
                <span>
                  <b>Caso não haja um número de matrícula</b> para ser
                  cadastrado &nbsp; orientamos que utilize o número do &nbsp;
                  <b>CPF</b>.
                </span>
              </InfoItem>

              <InfoItem>
                <span className="info">&#9432;</span>
                <span>
                  <b>
                    Em razão da LGPD, não é obrigatória a utilização do nome
                    completo do funcionário no campo "NOME". Pode inserir apenas
                    as iniciais de seu nome ou adotar outra informação que
                    atenda as necessidades internas da empresa.
                  </b>
                </span>
              </InfoItem>
            </InfoContainer>
          </Column>

          <Column small="10" medium="10" large="10">
            <Card>
              <div className="CardTitle">Dados</div>
              <div className="CardForm">
                <Row>
                  <Column small="12" medium="12" large="12">
                    <InputOutlined
                      name="Nome"
                      schema={schema}
                      label="NOME"
                      required
                    />
                  </Column>
                  <Column small="6" medium="6" large="6">
                    <InputOutlined
                      name="FuncCpf"
                      schema={schema}
                      cpf
                      label="CPF"
                      /* required */
                    />
                  </Column>
                  <Column small="6" medium="6" large="6">
                    <InputOutlined
                      name="Matricula"
                      schema={schema}
                      label="MATRÍCULA"
                      required
                    />
                  </Column>

                  <Column small="12" medium="12" large="12">
                    <SelectOutLined
                      name="CodigoDepartamento"
                      options={departamentoOptions}
                      schema={schema}
                      label="DEPARTAMENTO"
                      placeholder=""
                    />
                  </Column>
                  <Column small="12" medium="12" large="12">
                    <Checkbox
                      name="Status"
                      defaultValue="A"
                      options={[
                        {
                          id: 'ativo',
                          value: 'A',
                          label: 'Ativo',
                        },
                      ]}
                      checked={statusChecked}
                      onClick={() => setStatusChecked(!statusChecked)}
                    />
                  </Column>
                </Row>
              </div>
            </Card>
          </Column>
        </Row>

        <Row className="CardContainer">
          <Column small="2" medium="2" large="2">
            <InfoContainer
              style={{ cursor: 'pointer' }}
              onClick={() => setShowTarifas(true)}
            >
              <InfoItem className="infoitem">
                <span className="info">&#9432;</span>
                Clique aqui para consultar sobre os tipos de tarifa.
              </InfoItem>

              <InfoItem className="infoitem">
                <span className="info">&#9432;</span>
                Nesta seção, preencha a quantidade de passagens que este
                funcionário utiliza durante 1 dia útil. Após isso, na tela de
                Pedidos de Recarga &gt; Recarga por dia, o sistema irá calcular
                exatamente quanto esse funcionário utiliza de vale transporte
                por dia.
              </InfoItem>
            </InfoContainer>
          </Column>
          <Column small="10" medium="10" large="10">
            <Card style={{ minHeight: '96%' }}>
              <div className="CardTitle">Tarifas por dia</div>
              <div className="CardForm">
                <Form
                  ref={formTarifasRef}
                  onSubmit={handleSubmit}
                  className="TarifasForm"
                >
                  {addTarifas.map((tarifa: any, index: any) => (
                    <Row key={`key${index + 1}`}>
                      <Column
                        small="6"
                        medium="6"
                        large="6"
                        className="tarifaOptions"
                      >
                        <SelectOutLined
                          name={`tarifas[${index}].tarifa`}
                          options={tarifasOptions}
                          label={`Tarifa ${index + 1}`}
                          placeholder="Selecione a tarifa"
                        />
                      </Column>
                      <Column
                        small="5"
                        medium="5"
                        large="5"
                        className="tarifaOptions"
                      >
                        <InputOutlined
                          name={`tarifas[${index}].quantidade`}
                          type="number"
                          min="1"
                          defaultValue={tarifa.quantidade}
                          label={`Qtd. da tarifa ${index + 1}`}
                        />
                      </Column>
                      <Column
                        small="1"
                        medium="1"
                        large="1"
                        className="tarifaOptions"
                      >
                        {index > 0 && (
                          <Button
                            color="red"
                            type="button"
                            padding="1"
                            onClick={() => handleRemoveTarifa(index)}
                          >
                            <FaTrash />
                          </Button>
                        )}
                      </Column>
                    </Row>
                  ))}
                  {addTarifas.length <= 3 && (
                    <Button
                      color="purple"
                      type="button"
                      rounded
                      padding="2"
                      onClick={() => handleAddTarifa()}
                    >
                      ADICIONAR TARIFA
                    </Button>
                  )}
                </Form>
              </div>
            </Card>
            <div className="buttonsContainer">
              <Button color="orange" padding="1" rounded type="submit">
                CADASTRAR FUNCIONÁRIO
              </Button>
            </div>
          </Column>
        </Row>
      </Form>
      {showTarifas && (
        <TarifasModal
          show={showTarifas}
          title="Tarifas"
          handleClose={() => setShowTarifas(false)}
        />
      )}
    </Container>
  );
};

export default AddEmployee;
